import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import './Esoragoto.css';

const imageData = [
    {
        id: 1,
        src: '/animal.png',
        alt: 'Animal Artwork',
        title: 'Animal',
        description: '生命与自然的和谐对话，展现动物世界的纯粹美感与内在力量。通过抽象的表现手法，捕捉动物精神的本质。'
    },
    {
        id: 2,
        src: '/cosmos.png',
        alt: 'Cosmos Artwork',
        title: 'Cosmos',
        description: '浩瀚星空的无限可能，探索宇宙的奥秘与人类对未知的向往。在抽象与具象之间寻找平衡，展现宇宙的壮丽与神秘。'
    },
    {
        id: 3,
        src: '/dialog.png',
        alt: 'Dialog Artwork',
        title: 'Dialog',
        description: '人与人之间的交流与理解，通过视觉语言表达沟通的本质。在色彩与线条的交织中，展现对话的深度与广度。'
    }
];

const Esoragoto = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const navigate = useNavigate();

    const handleImageClick = (image) => {
        setSelectedImage(image);
    };

    const closeModal = () => {
        setSelectedImage(null);
    };

    return (
        <div className="suprematism-container">
            {/* Decorative Frame */}
            <div className="suprematism-frame">
                <div className="suprematism-frame-border suprematism-frame-tl"></div>
                <div className="suprematism-frame-border suprematism-frame-tr"></div>
                <div className="suprematism-frame-border suprematism-frame-b"></div>
                <div className="suprematism-frame-border suprematism-frame-l"></div>
            </div>

            <div className="suprematism-contents">
                {/* Logo */}
                <img
                    src="/logo.png"
                    alt="Logo"
                    className="suprematism-logo"
                    onClick={() => navigate('/')}
                />

                {/* Main Container */}
                <div className="suprematism-main-container">
                    <div className="suprematism-main-title">
                        <h2>绘空事</h2>
                    </div>

                    {/* Gallery Grid */}
                    <div className="suprematism-gallery">
                        {imageData.map((image) => (
                            <div
                                key={image.id}
                                className="suprematism-gallery-item"
                                onClick={() => handleImageClick(image)}
                            >
                                <div className="suprematism-image-container">
                                    <img
                                        src={image.src}
                                        alt={image.alt}
                                        className="suprematism-image"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'block';
                                        }}
                                    />
                                    <div className="suprematism-placeholder">
                                    </div>
                                </div>
                                <div className="suprematism-image-info">
                                    <h3>{image.title}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Modal for enlarged image */}
            {selectedImage && (
                <div className="suprematism-modal" onClick={closeModal}>
                    <div className="suprematism-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="suprematism-modal-close" onClick={closeModal}>×</button>
                        <img
                            src={selectedImage.src}
                            alt={selectedImage.alt}
                            className="suprematism-modal-image"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Esoragoto;